import React, { useState, useEffect } from "react";
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';

const getItemsFromPipefy = async (table_id, pipefy_token) => {
  console.log(table_id, pipefy_token);

  try {
    const queryString = new URLSearchParams({ table_id, pipefy_token }).toString();
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/pipefy/table-rows?${queryString}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const data = await response.json();
    const rows = data.rows.map((row) => row[0]);
    return rows || [];
  } catch (error) {
    console.error('Failed to fetch items from Pipefy:', error.message);
    return [];
  }
};

const Fields = ({ field, onChange, pipefy_token }) => {
  const [selectedCheckboxes, setSelectedCheckboxes] = useState(field.checked || []);
  const [items, setItems] = useState(field.items || []); // Estado para armazenar os itens

  useEffect(() => {
    if (field?.table_id) {
      const fetchItems = async () => {
        const fetchedItems = await getItemsFromPipefy(field.table_id, pipefy_token);
        setItems(fetchedItems);
      };

      fetchItems();
    }
  }, [field?.table_id, pipefy_token]);

  const handleBlur = (event) => {
    if (onChange) {
      if (field.type === "checkbox") {
        onChange({ target: { value: selectedCheckboxes } }, field.title);
      } else {
        onChange(event, field.title);
      }
    }
  };

  const handleCheckboxChange = (event) => {
    const value = event.target.value;
    const isChecked = event.target.checked;

    setSelectedCheckboxes((prevSelected) => {
      const updatedSelected = isChecked
        ? [...prevSelected, value]
        : prevSelected.filter((item) => item !== value);

      return updatedSelected;
    });
  };

  if (field.type === "select") {
    return field.editable ? (
      <select
        className="select"
        defaultValue={field.value}
        onBlur={handleBlur}
      >
        <option value="">
          Selecione uma opção
        </option>
        {items.map((item, idx) => (
          <option key={idx} value={item}>
            {item}
          </option>
        ))}
      </select>
    ) : (
      <select className="select" value={field.value} disabled>
        <option value="">
          Selecione uma opção
        </option>
        {items.map((item, idx) => (
          <option key={idx} value={item}>
            {item}
          </option>
        ))}
      </select>
    );
  }

  if (field.type === "checkbox") {
    return (
      <div className="checkbox-group">
        {items.map((item, idx) => (
          <label key={idx} className="checkbox-label">
            <input
              type="checkbox"
              className="checkbox"
              value={item}
              defaultChecked={selectedCheckboxes.includes(item)}
              disabled={!field.editable}
              onChange={handleCheckboxChange}
              onBlur={handleBlur}
            />
            {item}
          </label>
        ))}
      </div>
    );
  }

  if (field.type === "radio") {
    return (
      <div className="radio-group">
        {items.map((item, idx) => (
          <label key={idx} className="radio-label">
            <input
              type="radio"
              className="radio"
              name={field.title}
              value={item}
              defaultChecked={field.value === item}
              disabled={!field.editable}
              onBlur={handleBlur}
            />
            {item}
          </label>
        ))}
      </div>
    );
  }

  if (field.type === "dynamic-text") {
    return (
      <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]}>
        {field.message}
      </ReactMarkdown>
    )
  }

  // Renderiza input padrão para outros tipos
  return field.editable ? (
    <input
      type={field.type || "text"}
      className="input"
      maxLength={field.limit ?? null }
      defaultValue={field.message}
      onBlur={handleBlur}
      placeholder={field.placeholder ?? ""}
    />
  ) : (
    <input
      type={field.type || "text"}
      className="input"
      value={field.message}
      maxLength={field.limit ?? null }
      disabled={!field.editable}
      placeholder={field.placeholder ?? ""}
    />
  );
};

export default Fields;
